module.exports = __webpack_public_path__ + "static/media/photo_tkpa9_1.e3c424d3.gif";